<template>
	<div class="advertisement" v-if="config.setForm && show_Ad==1">
        <div class="ad_content">
            <a :href="language=='cn'?config.setForm.cn_adv_url:config.setForm.en_adv_url" class="ad_img" >
           <img :src="language=='cn'?config.setForm.cn_adv_indexpic:config.setForm.en_adv_indexpic" alt="">
        </a>
        <div class="close">
            <i @click="close" style="cursor: pointer;" class="el-icon-circle-close"></i>
        </div>
        </div>                                                                                              
	</div>
</template>

<script>
export default {
	data() {
		return {
		    config:{},
            show_Ad:2,
            language: sessionStorage.getItem("language") || "cn",

		}
	},
	mounted() {
         if(sessionStorage.getItem('config')){
            this.config=JSON.parse(sessionStorage.getItem('config'))
            if(sessionStorage.getItem('show_Ad')){
                this.show_Ad=sessionStorage.getItem('show_Ad')
            }else{
                this.show_Ad=1
                sessionStorage.setItem('show_Ad',1)
            }

         }
	},
	methods: {
	close(){
        this.show_Ad=2
        sessionStorage.setItem('show_Ad',2)
    },
	}
}
</script>

<style scoped>
     .advertisement{
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0,0,0,.5);
        z-index: 9999999999999 !important;
     }
     .ad_content{
        position: absolute;
        text-align: center;
        top: 20%;
        width: 30%;
        left: 50%;
        transform: translateX(-50%);
     }
     .advertisement .ad_img img{
        border-radius: 8px;
        overflow: hidden;
        width: 100%;
     }

     .close{
         color: #fff;
         font-size: 32px;
         position: absolute;
         right: 2%;
         top: 0;
     }
  
     @media screen and (max-width: 1200px) {
        .ad_content{
            width: 30% !important;
        }
     }
     @media screen and (max-width: 990px) {
        .ad_content{
            width: 60% !important;
        }
     }
     @media screen and (max-width: 768px) {
        .ad_content{
            width: 80% !important;
        }
     }
     
</style>
